export default __webpack_public_path__ + "static/media/management2.9e19e3c1.png";